import { Component, Input, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api/api.service';
import { PolicityService } from 'src/app/services/policity/policity.service';



@Component({
  selector: 'app-modal-privacy-policy',
  templateUrl: './modal-privacy-policy.component.html',
  styleUrls: ['./modal-privacy-policy.component.scss']
})
export class ModalPrivacyPolicyComponent implements OnInit {

  

  

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<ModalPrivacyPolicyComponent>, public policity: PolicityService) { }

  ngOnInit() {

  }

  closeModal(): void {

    this.dialogRef.close();


  }

  

}
